import React from "react";

import { MarketDashboardPage } from "@harrow-education/ui-components";

const MarketDashboard = ({ classroom }) => {
  return <MarketDashboardPage classroom={classroom} />;
};

export default MarketDashboard;
